"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:forbid-import */
var satcheljs_1 = require("satcheljs");
/* tslint:enable:forbid-import */
var saveOrDiscardOptions_1 = require("../utils/saveOrDiscardOptions");
exports.discardOptions = satcheljs_1.orchestratorAction('discardOptions', function discardOptions() {
    saveOrDiscardOptions_1.default(false);
});
//# sourceMappingURL=discardOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/orchestration/owa-options-orchestration/lib/orchestrators/discardOptions.js
// module id = 4913
// module chunks = 2